<div class="container-fluid">
  <form class="form-container" [formGroup]="form">
    <div class="filter-card">
      <div class="filters-wrapper">
        <!-- Date From -->
        <mat-form-field appearance="outline" class="filter-field" style="width: 220px;">
          <mat-label>Date From</mat-label>
          <input matInput [matDatepicker]="dateFromPicker" formControlName="dateFrom" [max]="form.get('dateTo')?.value"
            readonly />
          <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateFromPicker></mat-datepicker>
          <mat-error *ngIf="form.hasError('dateRangeInvalid')">Date From > Date To</mat-error>
        </mat-form-field>

        <!-- Date To -->
        <mat-form-field appearance="outline" class="filter-field" style="width: 220px;">
          <mat-label>Date To</mat-label>
          <input matInput [matDatepicker]="dateToPicker" formControlName="dateTo" [min]="form.get('dateFrom')?.value"
            readonly />
          <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateToPicker></mat-datepicker>
          <mat-error *ngIf="form.hasError('dateRangeInvalid')">Date To < Date From</mat-error>
        </mat-form-field>

        <!-- Delay Days -->
        <mat-form-field appearance="outline" class="filter-field" style="width: 120px;">
          <mat-label>Delay Days (&ge;)</mat-label>
          <input matInput type="number" formControlName="days" min="1" />
          <mat-error *ngIf="f['days'].errors?.['min']">Min 1 Day</mat-error>
          <mat-error *ngIf="f['days'].errors?.['required']">Required</mat-error>
        </mat-form-field>

        <!-- Assign To -->
        <mat-form-field appearance="outline" class="filter-field" style="width: 220px;">
          <mat-label>Assign To</mat-label>
          <mat-select formControlName="assignTo">
            <mat-option value="">ALL</mat-option>
            <mat-option *ngFor="let u of usersList" [value]="u.userId">
              {{ u.userName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Buttons -->
        <div class="button-container">
          <button mat-raised-button color="primary" [disabled]="form.invalid"
            style="background-color: #3f51b5; color: white; padding: 0 15px; height: 38px; line-height: 38px;"
            (click)="applyFilters()">
            <mat-icon style="margin-right: 4px;">filter_alt</mat-icon> Apply Filters
          </button>
          <button mat-stroked-button style="height: 38px; line-height: 38px; padding: 0 15px;" (click)="clearFilters()">
            <mat-icon style="margin-right: 4px;">close</mat-icon> Clear
          </button>
        </div>
      </div>
    </div>
    
    <div class="report-header">
      <h1>Daily Pending Complaints Report</h1>
      <div style="text-align: right; margin-bottom: 20px; padding-right: 15px;">
      <button mat-raised-button style="background-color: #0f854a; color: white;" (click)="exportExcel()">
        <mat-icon>download</mat-icon> Export Excel
      </button>
    </div>
    </div>

    
  </form>

  <div class="row" style="margin: 0 5px;">
    <!-- Complaint Categories -->
    <div class="col-md-6 mb-4">
      <mat-card class="data-card">
        <mat-card-header>
          <mat-card-title>Complaint Categories</mat-card-title>
          <mat-card-subtitle>Delays grouped by complainant & complaint type</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="table-container">
            <div class="table-scroll custom-scrollbar">
              <table mat-table [dataSource]="categoriesData" class="mat-elevation-z0 striped-table"
                style="width: 100%;">
                <ng-container matColumnDef="complainantType">
                  <th mat-header-cell *matHeaderCellDef> COMPLAINANT TYPE </th>
                  <td mat-cell *matCellDef="let element"> {{element.complainantType || element.complainant_type}} </td>
                  <td mat-footer-cell *matFooterCellDef style="font-weight: bold; color: black; background: #f8f9fa;">
                    TOTAL
                  </td>
                </ng-container>

                <ng-container matColumnDef="complaintType">
                  <th mat-header-cell *matHeaderCellDef> COMPLAINT TYPE </th>
                  <td mat-cell *matCellDef="let element"> {{element.complaintType || element.complaint_type}} </td>
                  <td mat-footer-cell *matFooterCellDef style="background: #f8f9fa;"> </td>
                </ng-container>

                <ng-container matColumnDef="count">
                  <th mat-header-cell *matHeaderCellDef> COUNT </th>
                  <td mat-cell *matCellDef="let element" style="color: #00917C; font-weight: bold;"> {{element.count ||
                    element.no_of_complaints || 0}} </td>
                  <td mat-footer-cell *matFooterCellDef style="color: #00917C; font-weight: bold; background: #f8f9fa;">
                    {{totalCategories}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['complainantType', 'complaintType', 'count']; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: ['complainantType', 'complaintType', 'count'];"></tr>
                <tr mat-footer-row *matFooterRowDef="['complainantType', 'complaintType', 'count']; sticky: true"
                  style="background: #f8f9fa;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="3" style="text-align: center; padding: 20px;">No Data Found</td>
                </tr>
              </table>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- GRMIS Users -->
    <div class="col-md-6 mb-4">
      <mat-card class="data-card">
        <mat-card-header>
          <mat-card-title>GRMIS Users</mat-card-title>
          <mat-card-subtitle>Delayed complaints by assigned officer</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="table-container">
            <div class="table-scroll custom-scrollbar">
              <table mat-table [dataSource]="usersData" class="mat-elevation-z0 striped-table" style="width: 100%;">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef> NAME </th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                  <td mat-footer-cell *matFooterCellDef style="font-weight: bold; color: black; background: #f8f9fa;">
                    TOTAL
                  </td>
                </ng-container>

                <ng-container matColumnDef="grmisUsers">
                  <th mat-header-cell *matHeaderCellDef> USERNAME </th>
                  <td mat-cell *matCellDef="let element"> {{element.username || element.grmis_users ||
                    element.grmisUsers}}
                  </td>
                  <td mat-footer-cell *matFooterCellDef style="background: #f8f9fa;"> </td>
                </ng-container>

                <ng-container matColumnDef="overdue">
                  <th mat-header-cell *matHeaderCellDef> COUNT </th>
                  <td mat-cell *matCellDef="let element" style="color: #00917C; font-weight: bold;"> {{element.count ||
                    element.no_of_complaints || element.overdue || 0}} </td>
                  <td mat-footer-cell *matFooterCellDef style="color: #00917C; font-weight: bold; background: #f8f9fa;">
                    {{totalUsers}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['name', 'grmisUsers', 'overdue']; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: ['name', 'grmisUsers', 'overdue'];"></tr>
                <tr mat-footer-row *matFooterRowDef="['name', 'grmisUsers', 'overdue']; sticky: true"
                  style="background: #f8f9fa;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="3" style="text-align: center; padding: 20px;">No Data Found</td>
                </tr>
              </table>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Complaint Details (Aging) -->
  <div class="row" style="margin: 0 5px;">
    <div class="col-12 mb-4">
      <mat-card class="data-card">
        <mat-card-header>
          <mat-card-title>Complaint Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="table-container">
            <div class="table-scroll custom-scrollbar" style="overflow-x: auto;">
              <table mat-table [dataSource]="agingDataSource" class="mat-elevation-z0 striped-table"
                style="width: 100%; min-width: 1000px;">
                <ng-container matColumnDef="sno">
                  <th mat-header-cell *matHeaderCellDef> S.No </th>
                  <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 + ((pageNo - 1) * pageSize) }} </td>
                </ng-container>

                <ng-container matColumnDef="complaintNo">
                  <th mat-header-cell *matHeaderCellDef> Complaint No </th>
                  <td mat-cell *matCellDef="let element"> {{element.complaintNo || element.complaint_no}} </td>
                </ng-container>

                <ng-container matColumnDef="complainantType">
                  <th mat-header-cell *matHeaderCellDef> Complainant Type </th>
                  <td mat-cell *matCellDef="let element"> {{element.complainantType || element.complainant_type}} </td>
                </ng-container>

                <ng-container matColumnDef="complaintType">
                  <th mat-header-cell *matHeaderCellDef> Complaint Type </th>
                  <td mat-cell *matCellDef="let element"> {{element.complaintType || element.complaint_type}} </td>
                </ng-container>

                <ng-container matColumnDef="assignTo">
                  <th mat-header-cell *matHeaderCellDef> Assign To </th>
                  <td mat-cell *matCellDef="let element"> {{element.assignTo || element.assign_to}} </td>
                </ng-container>

                <ng-container matColumnDef="daysElapsed">
                  <th mat-header-cell *matHeaderCellDef> Days Elapsed </th>
                  <td mat-cell *matCellDef="let element" style="color: #111111; font-weight: bold;">
                    {{(element.days || element.daysElapsed || element.days_elapsed) || 0}} Days
                  </td>
                </ng-container>

                <ng-container matColumnDef="district">
                  <th mat-header-cell *matHeaderCellDef> District </th>
                  <td mat-cell *matCellDef="let element"> {{element.district}} </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef> Status </th>
                  <td mat-cell *matCellDef="let element"> {{element.status}} </td>
                </ng-container>

                <tr mat-header-row
                  *matHeaderRowDef="['sno', 'complaintNo', 'complainantType', 'complaintType', 'assignTo', 'daysElapsed', 'district', 'status']; sticky: true">
                </tr>
                <tr mat-row
                  *matRowDef="let row; columns: ['sno', 'complaintNo', 'complainantType', 'complaintType', 'assignTo', 'daysElapsed', 'district', 'status'];">
                </tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="8" style="text-align: center; padding: 20px;">No Data Found</td>
                </tr>
              </table>
            </div>
            <div class="custom-paginator">
              <div class="total-items">
                Total Items: {{totalRows}}
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>